import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadService } from '../../expense/services/upload.service';
import { FilesService } from 'src/app/services/files.service';
import { HostService } from 'src/app/services/host.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-custom-table-header',
  templateUrl: './custom-table-header.component.html',
  styleUrls: ['./custom-table-header.component.scss']
})
export class CustomTableHeaderComponent {
  @Input() data: any[] = [];
  @Input() isEditingAll = false;
  @Input() showImportButton = false;
  @Input() showImportFileButton = false;
  @Input() subjectPropertyId = '';


  @Input() isSettingsOpen = false;
  @Input() columnsCopy: any[] = [];
  @Input() schemaName = '';
  @Input() tableVerticleView = false;
  @Input() enableSummary = false;
  @Input() enableAdjustment = false;
  @Input() showEnableSummary = false;
  @Input() showEnableAdjustment = false;

  @Output() settingsClicked = new EventEmitter<void>();
  @Output() editClicked = new EventEmitter<void>();
  @Output() saveClicked = new EventEmitter<void>();
  @Output() cancelClicked = new EventEmitter<void>();
  @Output() searchClicked = new EventEmitter<void>();
  @Output() fileUploaded = new EventEmitter<Event>();

  @Output() applySettingsClicked: any = new EventEmitter<void>();
  @Output() settingsClosed = new EventEmitter<void>();
  isUploading: boolean = false;

  constructor(private uploadService: UploadService, private filesService: FilesService, private hostService: HostService) { }


  applySettings() {
    const data = {
      columns: this.columnsCopy,
      view: this.tableVerticleView,
      enableSummary: this.enableSummary,
      enableAdjustment: this.enableAdjustment
    };
    this.applySettingsClicked.emit({
      type: 'tableViewUpdate',
      data: data,
      schemaName: this.schemaName
    });

  }


}


